import { createContext, useContext } from "react";

export const PanelCtx = createContext(null);
export const usePanel = () => useContext(PanelCtx);
